import { ActionLink } from "@/components/ActionLink";
import { MediaCard } from "@/components/MediaCard";
import { SectionHeading } from "@/components/SectionHeading";
import { creativeArchive, creativeFeatures, routeCtas } from "@/data/siteContent";

export function CreativeLabPage() {
  return (
    <div>
      <section className="relative overflow-hidden px-4 pb-24 pt-14 md:px-8 md:pt-20">
        <div className="absolute inset-0">
          <img src="/assets/creative-lab/image-01.webp" alt="" className="h-full w-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-background/70 to-background" />
        </div>
        <div className="relative mx-auto max-w-5xl space-y-8 rounded-[2.5rem] border border-outline/10 bg-surface/55 p-8 text-center shadow-ambient backdrop-blur md:p-12">
          <p className="eyebrow !mx-auto !inline-flex">The creative lab</p>
          <h1 className="font-display text-5xl leading-[1.03] text-text md:text-7xl">
            Visual work with a <span className="italic text-primary">technical spine</span>
          </h1>
          <p className="mx-auto max-w-3xl text-lg leading-8 text-muted">
            This is where 3D capture, post-production, and in-between experiments live. Some of it is polished. Some of
            it is still becoming itself.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {routeCtas["/creative-lab"].map((action, index) => (
              <ActionLink
                key={action.label}
                action={action}
                variant={index === 0 ? "primary" : "secondary"}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="Featured work"
            title="Experiments in image, space, and motion"
            description="A place for Gaussian splatting, digital capture, color, and other work that sits somewhere between engineering and image-making."
          />
          <div className="grid gap-8 md:grid-cols-[1.25fr_0.75fr]">
            {creativeFeatures.map((card, index) => (
              <MediaCard key={card.title} card={card} compact={index === 1} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-surface-low px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="Archive"
            title="Work worth keeping"
            description="Smaller studies, fragments, and finished pieces that still say something useful about the direction of the work."
          />
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {creativeArchive.map((card) => (
              <MediaCard key={card.title} card={card} compact />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

